import { Route } from "../Models/Route";
import { CopyFilled, LockOutlined, ReadOutlined, SendOutlined, SettingFilled, SettingOutlined, ShopFilled, ShopOutlined, UserOutlined } from '@ant-design/icons';

export const clientRoutes: Route[] = [
    {path: "/panel", icon: <> </> , navbarShow: false, regex:null, name:""},


    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]

export const adminRoutes: Route[] = [
    {path: "/catalogo", icon: <ShopFilled /> , navbarShow: true, regex:null, name:"Catalogo"},
    {path: "/orden", icon: <CopyFilled /> , navbarShow: true, regex:null, name:"Ordenes"},
    {path: "/ajustes", icon: <SettingFilled /> , navbarShow: true, regex:null, name:"Configuración"},





    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]

export const nonRoutes: Route[] = [
    {path: "/productos", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/proximamente", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/cartas", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/login", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/loginadmin", icon: <> </> , navbarShow: false, regex:null, name:""},



    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]